import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Input, ViewChild, SimpleChanges } from '@angular/core';
import { api } from '../URL/api-url';
import Swal from 'sweetalert2';
import { UpdateAddressComponent } from '../update-address/update-address.component';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';;

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})

export class SideBarComponent {

  downloadCollapse = false;

  PhzioMSK360: boolean = true;
  SolidGroundMethod: boolean = true;
  Alavida: boolean = true;
  NortonLifeLock: boolean = true;
  MyHsa: boolean = true;
  Equitqble: boolean = true;
  Greenshild: boolean = true;
  ENHCanada: boolean = true;
  CloudMD: boolean = true;
  RxFood: boolean = true;
  LifeSpeak: boolean = true;
  lifeSession: boolean = true;
  Carequest: boolean = true;
  newsLinkjan: any;
  newsLinkfed: any;
  newsLinkmar: any;
  showChevronDown: boolean = true;
  showChevronDownForNews: boolean = true;
  showChevronSettings: boolean = true;
  formConfiguration: any;
  showupdatesignatue: boolean = true;
  lang: any = {};
  selectedLanguage: any = '';
  lang1: any = {};
  historyLength: any;
  newLinks: any[] = [];
  link: any;
  failedsignature: any[] = [];
  signaturePadOptions1: Object = {
    'minWidth': 2,
    'canvasWidth': 700,
    'canvasHeight': 300
  };
  showChevronDownhealth: boolean = true;
  showChevronDownwellness: boolean = true;
  showChevronDownbenefits: boolean = true;
  headername: any;
  @ViewChild(UpdateAddressComponent) updateaddress!: UpdateAddressComponent;
  @ViewChild('closebutton') closebutton;
  @Input() formConfig!: any;

  customerid: any;
  accessToken: any;
  showconfirm: any = false;
  showcancel: any = false;
  greenshildcheck: any;
  equitablecheck: any;
  websitetitle: any;
  websitelink: any;
  clientName: any;
  fileName: any;
  filetype: any;
  failedROE: any;
  padaggrement: any;
  encBank: any;
  firstName: any;
  signatureImg: any;
  waddelCustomer: any;
  loading: boolean = true;
  selectedItemIndex: any = 1;
  selectedItemIndex1: number | null = null;
  selectedItemIndex2: number | null = null;
  isViking: boolean = false;
  isNhlaa: boolean = false;
  currClient:any = ""
  constructor(private http: HttpClient, private sanitizer: DomSanitizer, 
  ) { }



  downloads() {

    this.downloadCollapse = !this.downloadCollapse;


  }
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  checkWaddell: any
hideLifeCiMenus!: boolean;
hideProvidersNearMe!: boolean;



  ngOnInit() {
     this.overrideSessionStorageSetItem();
      this.syncSidebarVisibility();
       if (this.hideLifeCiMenus) {
    this.forceCloseMemberPortalCollapse();
  }

  // initial read (important)
 this.hideLifeCiMenus =
  sessionStorage.getItem('hideLifeCiMenus') === 'true';

this.hideProvidersNearMe =
  sessionStorage.getItem('hideProvidersNearMe') === 'true';


    this.getLanguageTokens()

    this.customerid = sessionStorage.getItem('customerId');
    this.accessToken = sessionStorage.getItem('accessToken');
    this.clientName = sessionStorage.getItem('customerName');
    this.isViking = JSON.parse(sessionStorage.getItem('isViking') || "false");
    this.isNhlaa = JSON.parse(sessionStorage.getItem('isNhlaa') || "false");
    this.currClient = sessionStorage.getItem('currClient') ??  "";
    this.getFormConfiguration('en');
    this.historyLength = window.history.length;
    const state = history.state;
  console.log("Sidebar received state:", state);

  this.hideLifeCiMenus = state?.lifeCiSelected === true;

  console.log("Final hideLifeCiMenus:", this.hideLifeCiMenus);


    setTimeout(() => {
      this.greenshildcheck = sessionStorage.getItem("GreenShild")
      this.equitablecheck = sessionStorage.getItem("Equitable")
    }, 5000);
    this.getACHDetails()
  }
  private forceCloseMemberPortalCollapse() {
  const elements = document.querySelectorAll('.multi-collapse.show');
  elements.forEach(el => el.classList.remove('show'));
}

  syncSidebarVisibility() {
  this.hideLifeCiMenus =
    sessionStorage.getItem('hideLifeCiMenus') === 'true';

  this.hideProvidersNearMe =
    sessionStorage.getItem('hideProvidersNearMe') === 'true';

  console.log(
    'Sidebar sync →',
    this.hideLifeCiMenus,
    this.hideProvidersNearMe
  );
}

overrideSessionStorageSetItem() {
  const originalSetItem = sessionStorage.setItem.bind(sessionStorage);

  sessionStorage.setItem = (key: string, value: string) => {
    originalSetItem(key, value);

    if (key === 'hideLifeCiMenus') {
      this.hideLifeCiMenus = value === 'true';
      console.log('override → hideLifeCiMenus:', this.hideLifeCiMenus);
    }

    if (key === 'hideProvidersNearMe') {
      this.hideProvidersNearMe = value === 'true';
      console.log('override → hideProvidersNearMe:', this.hideProvidersNearMe);
    }
  };
}

  selectItem(index: number) {
    this.selectedItemIndex = index;
    this.selectedItemIndex1 = null



  }


  selectSubItem(index: number) {
    this.selectedItemIndex1 = index;

    this.selectedItemIndex2 = null

  }
  pdfLoaded(event: any) {
    console.log(event)
    setTimeout(() => {
      this.loading = false
    }, 1000);

  }
  closeNewsLetters() {

  }
  getCustomerData(customer?:any) {
        const response = {data:customer}
        this.failedsignature = response.data.failedDocs

        this.failedROE = response.data.newroes[0]

        this.firstName = response.data.firstName
        this.waddelCustomer = response.data.serviceType.waddelCustomer



  }

  getACHDetails() {
    let customerDataEndpoint = '/customer/' + this.customerid + '/achDetails';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.padaggrement = response.data ? response.data?.achDetails?.data?.padAgreement : ''


        let inputData1 = {
          bankCode: response.data ? response.data.achDetails.data?.bankCode : '',
          branchCode: response.data ? response.data.achDetails.data?.transitNumber : '',
          accountNumber: response.data ? response.data.achDetails.data?.accountNumber : '',
        };

        this.encBank = btoa(JSON.stringify(inputData1));

      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Sidebar"
    }
    this.http
      .post(api.lang + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response)
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem('language') || 'English'
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          console.log(this.lang)
        }
      )
  }

  viewDocument(file: any) {
    this.filetype = ""
    this.sigPadElement = this.sigPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = 'black';
    this.fileName = file
    if (file == "ROE") {
      this.filetype = this.failedROE.link

    } else {
      this.filetype = this.padaggrement && this.padaggrement != undefined ? this.padaggrement : ''

    }

  }


  openwebsite(title: any, link: any) {
    $('#website').show();
    setTimeout(() => {
      this.websitetitle = this.lang[title];
      this.websitelink = this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }, 5000);


  }
  closewebsitemodal() {
    $('#website').hide();
  }

  getFormConfiguration(lang: any) {


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formConfig'] && changes['formConfig'].currentValue) {
      console.log(this.formConfig)
      this.formConfiguration = this.formConfig;
      var orderedDates: any = {};
      Object.keys(this.formConfiguration.news).sort(function (a, b) {
        let dateA: any = moment(a, 'MMM-YYYY').toDate();
        let dateB: any = moment(b, 'MMM-YYYY').toDate();
        // Sort in descending order
        return dateB - dateA;
      })
      .forEach((key) => {
        orderedDates[key] = this.formConfiguration.news[key];
      })
      this.newLinks = Object.keys(orderedDates)
      this.newsLinkjan = this.formConfiguration.news['jan'];
      this.newsLinkfed = this.formConfiguration.news['feb'];
      this.newsLinkmar = this.formConfiguration.news['mar'];
    }
  }


  toggleChevron() {
    this.showChevronDown = !this.showChevronDown;
    if (this.showChevronDown == true) {
      this.showChevronDownhealth = true;
      this.showChevronDownwellness = true;
      this.showChevronDownbenefits = true;
    }
  }
  toggleChevron1() {
    this.showChevronDownForNews = !this.showChevronDownForNews;
  }
  toggleChevron2() {
    this.showChevronDownhealth = !this.showChevronDownhealth;
  }
  toggleChevron3() {
    this.showChevronDownwellness = !this.showChevronDownwellness;
  }
  toggleChevron4() {
    this.showChevronDownbenefits = !this.showChevronDownbenefits;
  }
  toggleChevron5() {

    this.showChevronSettings = !this.showChevronSettings;
  }
  newletters(month: any) {
    this.link = this.formConfiguration.news[month];
    this.headername = month;


  }
  drawComplete1() {
    this.showconfirm = false
  }

  drawStart1() {
    this.showcancel = false;
  }
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
      this.showupdatesignatue = false;
    }
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }

  clearSignature() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
    this.showupdatesignatue = true;
  }

  //save signature for ROE
  saveSignature() {
    const base64Data = this.sigPadElement.toDataURL();
    this.signatureImg = base64Data;
    let Endpoint = '/customer/' + this.customerid + '/signature';
    let data = {
      sign: this.signatureImg,

    }
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        Swal.fire({ title: this.lang?.Info, text: response.message })

        if (this.fileName == "PAD") {
          this.savePad()
        }
        else {
          window.location.reload()
        }

      }
      else {
        Swal.fire({ title: this.lang?.Error, text: response.message })
      }
    }, (error) => {
      Swal.fire({ title: this.lang?.Error, text: error.error.error.message })
    });
  }

  savePad() {
    const base64Data = this.sigPadElement.toDataURL();
    this.signatureImg = base64Data;
    let Endpoint = '/customer/' + this.customerid + '/updatePAD';
    let data = {
      url: this.padaggrement,
      signature: this.signatureImg,
      filename: "PAD_Agreement_" + this.firstName.replaceAll(' ', '') + "_" + this.customerid + "_" + Date.now(),
    }
    this.http.post(api.url + Endpoint, data, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        window.location.reload()
      }
      else {
      }
    }, (error) => {
    });
  }

}
